import React, { ReactNode } from 'react';
import { Flex, theme as antTheme } from 'antd';

type Props = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const BlockHeaderLabel = ({ children, style }: Props) => {
  const { token } = antTheme.useToken();

  const titleStyle: React.CSSProperties = {
    color: token.Menu.itemColor,
    fontSize: token.fontSizeLG,
    fontWeight: 600,
    marginTop: '2rem',
    marginBottom: '1rem',
    ...style,
  };

  return (
    <div style={titleStyle}>
      <Flex justify={'center'}>{children}</Flex>
    </div>
  );
};

export default BlockHeaderLabel;
